<template>
  <div style="overflow: hidden;">
    <el-row style="text-align: left;">
      <!-- <el-button type="success" size="mini" plain @click="addRootNode">添加根节点</el-button> -->
      <el-button type="primary" size="mini" round @click="saveTree">确认</el-button>
    </el-row>
    <!-- Tree组件 -->
    <el-tree style="margin-top: 10px;border-radius: 4px;" ref="tree" :data="treeData" :indent="0" node-key="id"
      default-expand-all :props="defaultProps" @node-contextmenu="handleRightClick" :filter-node-method="filterNode"
      draggable @node-drop="handleDrop">
    </el-tree>

    <!-- 右键菜单 -->
    <div v-show="contextMenuVisible" :style="{left: menuLeft+'px', top: menuTop+'px'}" class="context-menu">
      <div class="menu-item" @click="addNode">新增子节点</div>
      <div class="menu-item" @click="editNode">修改节点</div>
      <div class="menu-item" @click="deleteNode">删除节点</div>
    </div>
    <!-- 弹出 -->
    <div>
      <el-dialog title="修改" :visible.sync="dialogFormVisible">
        <el-form :model="formNode">
          <el-form-item label="名称" style="text-align: left;">
            <el-input v-model="formNode.name" autocomplete="off" style="width:100%;text-align: left;"></el-input>
          </el-form-item>
          <el-form-item v-if="formNode.realID" label="主图" >
            <el-upload class="avatar-uploader" action="" :show-file-list="false" :file-list="fileList"
              :before-upload="handleBeforeUpload" :on-change="handleFileChange">
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="upDateNode">确 定</el-button>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

  import { submitVlogType, getVlogType } from "@/api/rbac/vlog";
  import { hasDuplicateNames, findMaxIdInTree } from "@/api/rbac/tree";
  import {submitCenterPic} from "@/api/rbac/home";

  let maxID = 0;
  export default {
    data() {
      return {
        treeData: [{
          id: 0,
          name: '根节点',
          children: []
        }],
        defaultProps: { children: 'children', label: 'name' },
        contextMenuVisible: false,
        menuLeft: 0,
        menuTop: 0,
        currentNode: null,  // 当前右键点击的节点 
        currentParent: null,  // 当前节点的父节点 
        dialogFormVisible: false,
        formNode: { id: 0, name: '' ,img:''},
        imageUrl: '',
        fileList: [],
      }
    },
    created() {
      this.getTypeList();
    },
    methods: {

      // 右键点击事件 
      handleRightClick(event, data, node) {
        event.preventDefault()
        this.currentNode = node
        node.expanded = true
        this.currentParent = node.parent
        this.menuLeft = event.clientX
        this.menuTop = event.clientY
        this.contextMenuVisible = true
        this.imageUrl = ''
        if (this.currentNode.data.url) {
          this.imageUrl = '../../../assets/img/Vlog/' + this.currentNode.data.url
        }
      },
      // 新增根节点
      addRootNode() {
        this.treeData.push({
          id: 0,
          name: '新根节点',
          children: []
        });
        // this.$ref.tree.$forceUpdate();
      },
      // 新增节点 
      addNode() {
        maxID++;
        const newChild = { id: maxID, name: '新节点' }
        if (!this.currentNode.data.children) {
          this.$set(this.currentNode.data, 'children', [])
        }
        this.currentNode.data.children.push(newChild)
        this.contextMenuVisible = false
      },

      // 修改节点 
      editNode() {
        this.dialogFormVisible = true;
        this.formNode.name=this.currentNode.data.name
        this.formNode.img=this.currentNode.data.img
        this.formNode.realID=this.currentNode.data.realID
        //   this.$prompt('请输入新名称', '提示', {
        //     inputValue: this.currentNode.data.label  
        //   }).then(({ value }) => {
        //     this.currentNode.data.label  = value 
        //     this.currentNode.loaded=false;
        //   })
        this.contextMenuVisible = false
      },
      upDateNode() {
        const formData = new FormData();
        console.log(this.fileList)
        if (this.fileList.length > 0) {
          this.fileList.forEach((file) => {
            formData.append('files[]', file.raw);
          });
          formData.append("strType", "vlogType");
          formData.append("partID", this.formNode.realID);
          try {
            submitCenterPic(formData).then(res => {
              if (res.length == 0) {
                alert('上传失败');
              }
              else {
                alert('上传成功');
                // this.dialogVisible=false;
              }
            })

          } catch (error) {
            alert('未成功');
          }
        }
        this.currentNode.data.name = this.formNode.name;

        this.currentNode.loaded = false;
        this.dialogFormVisible = false;
      },
      // 删除节点 
      deleteNode() {
        this.$confirm('确认删除该节点？').then(() => {
          const parent = this.currentParent.data
          const index = parent.children.findIndex(d => d.id === this.currentNode.data.id)
          parent.children.splice(index, 1)


          // 清除选中节点
          this.selectedNode = null;
        })
        this.contextMenuVisible = false
      },
      findNodeAndParent(nodes, nodeId, parent = null) {
        for (let i = 0; i < nodes.length; i++) {
          if (nodes[i].id === nodeId) {
            return { node: nodes[i], parent, index: i };
          }
          if (nodes[i].children) {
            const result = this.findNodeAndParent(nodes[i].children, nodeId, nodes[i]);
            if (result.node) {
              return result;
            }
          }
        }
        return { node: null, parent: null, index: -1 };
      },
      // 节点拖拽处理 
      handleDrop(draggingNode, dropNode, type) {
        console.log(' 拖拽后数据:', this.treeData, draggingNode, type, dropNode)
      },
      // findMaxIdInTree(nodes) {
      //    let createID=0;
      //   const traverse = (nodeArray) => {
      //     for (const node of nodeArray) {
      //       const nodeId = parseInt(node.id, 10); // 确保 ID 是数字类型进行比较
      //       if (nodeId > createID) {
      //         createID = nodeId;
      //       }
      //       if (node.children && node.children.length > 0) {
      //         traverse(node.children);
      //       }
      //     }
      //   };

      //   traverse(nodes);
      //   return createID;
      // },
      //获取数据
      getTypeList() {
        getVlogType().then(res => {
          if (res.data.length == 0) {
            // console.log(this.treeData)
          }
          else {
            this.treeData = res.data;
          }
          maxID = findMaxIdInTree(this.treeData);
        })
      },
      handleBeforeUpload(file) {
        console.log(file)
        return false;
      },
      handleFileChange(file, fileList) {
        console.log('fileList', fileList)
        this.fileList = [];
        this.fileList.push(file)
        if (file.status === 'ready') {
          // 当文件状态为 ready 时，生成预览 URL
          const reader = new FileReader();
          reader.onload = (e) => {
            this.imageUrl = e.target.result;
          };
          reader.readAsDataURL(file.raw);
        }
      },

      //保存tree
      saveTree() {
        if (hasDuplicateNames(this.treeData)) {
          return alert("有重复节点名称");
        }
        submitVlogType(this.treeData).then(res => {
          if (res.data == "ok") {
            // console.log(this.treeData)
            this.getTypeList();
          }
          else {
            alert("保存失败")
          }
        })
      },
      // 过滤搜索 
      filterNode(value, data) {
        if (!value) return true
        return data.label.indexOf(value) !== -1
      }
    }
  }
</script>

<style scoped>
  :deep(.el-dialog) {
    max-width: 500px;
  }

  .tree-container {
    position: relative;
    height: 500px;
    padding: 10px;
  }

  .context-menu {
    position: fixed;
    z-index: 9999;
    background: gray;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    padding: 10px;
    display: flex;
    flex-direction: column;
  }

  .menu-item {
    padding: 8px 15px;
    cursor: pointer;
  }

  .menu-item:hover {
    background-color: black;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  .el-input {
    width: 120px;
  }
</style>